(function() {
    'use strict';

    angular
        .module('womenCellApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('about-us', {
            parent: 'app',
            url: '/about-us',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/about-us/about-us.html',
                    controller: 'AboutUsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('about-us');
                    return $translate.refresh();
                }]
            }
        }),
        $stateProvider.state('constitution', {
            parent: 'app',
            url: '/constitution',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/about-us/constitution.html',
                    controller: 'AboutUsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('about-us');
                    return $translate.refresh();
                }]
            }
        }),
        $stateProvider.state('hscwact', {
            parent: 'app',
            url: '/hscwact',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/about-us/hscwact.html',
                    controller: 'AboutUsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('about-us');
                    return $translate.refresh();
                }]
            }
        });
        $stateProvider.state('hscwfunctions', {
            parent: 'app',
            url: '/hscwfunctions',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/about-us/hscwfunctions.html',
                    controller: 'AboutUsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('about-us');
                    return $translate.refresh();
                }]
            }
        });
         $stateProvider.state('hscwpowers', {
            parent: 'app',
            url: '/hscwpowers',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/about-us/powershscw.html',
                    controller: 'AboutUsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('about-us');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
